import styled from 'styled-components';

import { breakpoints, fontSizesByType, shadows, transition } from 'theme';

export const Title = styled.div<{ lineHeight?: number }>`
  font-size: ${fontSizesByType.h3[0]}px;
  @media (min-width: ${breakpoints[1]}) {
    font-size: ${fontSizesByType.h3[2]}px;
  }
`;

export const FixedMenu = styled.div<{ $sticky?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  box-shadow: ${shadows.toolbar};
  transition: all ${transition};
  will-change: transform;
  transform: ${({ $sticky }) =>
    $sticky ? 'translateY(0)' : 'translateY(-100%) translateY(-4px)'};
`;
